import {create} from "zustand";
import {derivedRemoteStore} from "./DerivedStore";
import {Employee, Team} from "./Model";
import {useTeamStore} from "./TeamStore";

export class TeamTree {
    private readonly teams: Map<string, Team> = new Map<string, Team>();

    constructor(teams: Team[]) {
        teams.forEach(team => this.teams.set(team.id, team));
    }

    path(employee: Employee): Team[] | undefined {
        const teamId = employee.teamId;
        if (!teamId) return undefined;

        const path: Team[] = [];
        for (let team = this.teams.get(teamId); team; team = team.parentId ? this.teams.get(team.parentId) : undefined) {
            path.unshift(team);
        }
        return path.length > 0 ? path : undefined;
    }
}

export const useTeamTreeStore = create(
    derivedRemoteStore(
        {teams: useTeamStore},
        ({teams}) => new TeamTree(teams),
    )
);